var map = {
	"./Others.png": 5352,
	"./art.jpeg": 9336,
	"./cropped_logo.jpg": 119,
	"./dance.jpg": 5864,
	"./dance1.jpeg": 4848,
	"./dance2.jpeg": 5916,
	"./exam.jpg": 1140,
	"./fitness.jpg": 8424,
	"./fitness1.jpeg": 368,
	"./fitness10.jpg": 7228,
	"./fitness11.jpg": 1024,
	"./fitness2.jpeg": 700,
	"./fitness3.jpeg": 4936,
	"./fitness4.jpeg": 5404,
	"./fitness5.jpeg": 664,
	"./fitness6.jpg": 4140,
	"./fitness7.jpg": 7924,
	"./fitness8.jpg": 9432,
	"./fitness9.jpg": 2500,
	"./gym1.jpeg": 9620,
	"./gym2.jpeg": 9524,
	"./gym3.jpeg": 6284,
	"./gym4.jpeg": 424,
	"./gym5.jpg": 3228,
	"./gym6.jpg": 9040,
	"./gym7.jpg": 652,
	"./jiu jitsu.jpg": 9100,
	"./jiu jitsu2.jpg": 884,
	"./kid ballet.jpeg": 648,
	"./logo.jpg": 9396,
	"./marker_blue.png": 2004,
	"./marker_dotted.png": 7300,
	"./martial arts.jpg": 1792,
	"./online gym1.jpg": 764,
	"./online gym2.jpg": 1076,
	"./online yoga1.jpeg": 9036,
	"./online yoga2.jpeg": 4948,
	"./online yoga3.jpeg": 8820,
	"./online yoga4.jpeg": 7964,
	"./online yoga5.jpg": 4212,
	"./study.jpg": 4792,
	"./study2.jpg": 8384,
	"./study3.jpg": 1704,
	"./yoga.jpg": 112,
	"./yoga1.jpg": 6344
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1360;